<template>
  <div class="virtual-page app-page">
    <div class="app-workbench">
      <main class="virtual-main">

        <!-- 返回聊天 -->
        <div class="back-to-chat-bar">
          <router-link to="/virtual-chat" class="back-to-chat-link">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            返回虚拟恋人聊天
          </router-link>
        </div>

        <!-- 加载与错误提示 -->
        <div v-if="loading && !formData.name" class="loading">
          <div class="spinner"></div>
          <p>加载中...</p>
        </div>
        <div v-if="error" class="error-message">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          {{ error }}
        </div>

        <!-- 核心内容区 -->
        <div v-if="!loading || formData.name" class="virtual-card">
          <!-- 装饰性背景元素 -->
          <div class="decoration-circle decoration-circle--top-left"></div>
          <div class="decoration-circle decoration-circle--bottom-right"></div>

          <!-- 渐变 Banner -->
          <div class="virtual-banner">
            <div class="virtual-banner-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <div class="virtual-banner-title">专属设定</div>
            <p class="virtual-banner-desc">在这里定义你心中的TA，每一个细节都将决定你们的互动体验</p>
          </div>

          <div class="virtual-body">
            <!-- 左右分栏 -->
            <div class="virtual-content">
              <!-- 左侧表单 -->
              <div class="form-container">
                <!-- 头像 -->
                <div class="avatar-setting-section">
                  <div class="avatar-display-wrapper" @click="handleAvatarClick">
                    <div class="avatar-circle">
                      <img
                        v-if="formData.avatar"
                        :src="formData.avatar"
                        alt="虚拟对象头像"
                        class="avatar-img"
                        @error="handleAvatarError"
                      >
                      <svg v-else width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="8" r="4" stroke="#FF7E7E" stroke-width="1.5"/>
                        <path d="M4 20c0-4 3.58-7 8-7s8 3 8 7" stroke="#FF7E7E" stroke-width="1.5"/>
                      </svg>
                    </div>
                    <div class="avatar-hint-text">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>
                      点击更换头像
                    </div>
                  </div>
                </div>

                <!-- 表单 -->
                <el-form
                  ref="formRef"
                  :model="formData"
                  :rules="rules"
                  label-width="80px"
                  class="virtual-form"
                >
                  <el-form-item label="名字" prop="name">
                    <el-input
                      v-model="formData.name"
                      placeholder="给TA起个名字"
                      clearable
                      size="large"
                    />
                  </el-form-item>

                  <div class="form-row">
                    <el-form-item label="性别" prop="gender" class="gender-item">
                      <el-radio-group v-model="formData.gender" size="large">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="年龄" class="age-item">
                      <el-input-number
                        v-model="formData.age"
                        :min="1"
                        :max="100"
                        size="large"
                      />
                    </el-form-item>
                  </div>

                  <el-form-item label="职业">
                    <el-input
                      v-model="formData.job"
                      placeholder="TA的职业是什么 (如: 设计师、程序员)"
                      clearable
                      size="large"
                    />
                  </el-form-item>

                  <el-form-item label="性格" prop="personality">
                    <el-input
                      v-model="formData.personality"
                      type="textarea"
                      :rows="2"
                      placeholder="描述一下TA的性格 (如: 温柔体贴、活泼开朗)"
                      size="large"
                    />
                  </el-form-item>

                  <el-form-item label="爱好">
                    <el-input
                      v-model="formData.hobbies"
                      type="textarea"
                      :rows="2"
                      placeholder="TA喜欢做什么 (如: 看电影、旅行)"
                      size="large"
                    />
                  </el-form-item>

                  <el-form-item label="简介">
                    <el-input
                      v-model="formData.introduction"
                      type="textarea"
                      :rows="3"
                      placeholder="一段简短的自我介绍"
                      size="large"
                    />
                  </el-form-item>

                  <el-form-item class="form-actions">
                    <el-button
                      type="primary"
                      @click="handleSubmit"
                      :loading="submitLoading"
                      size="large"
                      class="submit-btn"
                    >
                      <span v-if="characterId">保存修改</span>
                      <span v-else>立即创建</span>
                    </el-button>
                    <el-button @click="resetForm" size="large" class="reset-btn">重置</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <!-- 右侧装饰侧边栏 -->
              <div class="decoration-sidebar">
                <div class="sidebar-card">
                  <div class="sidebar-card-header">
                    <span class="sidebar-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                    </span>
                    <h3>小贴士</h3>
                  </div>
                  <ul class="tips-list">
                    <li>上传一张清晰的头像，会让TA更有真实感</li>
                    <li>详细的性格描述能让AI更好地模仿TA的说话方式</li>
                    <li>填写TA的爱好，你们会有更多共同话题</li>
                    <li>简介可以写一些TA的口头禅和习惯</li>
                  </ul>
                </div>

                <div class="sidebar-card">
                  <div class="sidebar-card-header">
                    <span class="sidebar-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                    </span>
                    <h3>快速生成</h3>
                  </div>
                  <p class="sidebar-desc">不知道怎么写？试试一键生成示例人设</p>
                  <div class="generate-buttons-grid">
                    <button
                      type="button"
                      class="generate-btn btn-sweet"
                      @click="generateSweetGirl"
                    >
                      🍬 甜妹系
                    </button>
                    <button
                      type="button"
                      class="generate-btn btn-gentle"
                      @click="generateGentleGirl"
                    >
                      🌸 温柔系
                    </button>
                    <button
                      type="button"
                      class="generate-btn btn-vitality"
                      @click="generateVitalityGirl"
                    >
                      ☀️ 元气系
                    </button>
                    <button
                      type="button"
                      class="generate-btn btn-cool"
                      @click="generateCoolGirl"
                    >
                      🌙 清冷系
                    </button>
                    <button
                      type="button"
                      class="generate-btn btn-queen full-width-btn"
                      @click="generateQueenGirl"
                    >
                      👑 御姐系
                    </button>
                  </div>
                  <el-divider style="margin: 16px 0;"></el-divider>
                  <button
                    type="button"
                    class="generate-btn btn-male"
                    @click="generateMaleExample"
                  >
                    ☀️ 阳光男生
                  </button>
                </div>

                <div class="decoration-bubble bubble-1"></div>
                <div class="decoration-bubble bubble-2"></div>
                <div class="decoration-bubble bubble-3"></div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>

    <!-- 头像上传弹窗 -->
    <el-dialog
      title="更换头像"
      v-model="avatarDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :append-to-body="true"
      class="avatar-dialog"
    >
      <el-upload
        class="avatar-uploader"
        action=""
        :show-file-list="false"
        :on-change="handleFileChange"
        :before-upload="beforeAvatarUpload"
        accept="image/jpeg,image/png"
      >
        <div v-if="tempAvatarUrl" class="avatar-preview-wrapper">
          <img :src="tempAvatarUrl" class="avatar-preview-img">
        </div>
        <div v-else class="upload-placeholder">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#B2BEC3" stroke-width="1.5"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>
          <span>选择图片</span>
        </div>
        <div class="upload-hint">支持JPG、PNG格式，大小不超过5MB</div>
      </el-upload>

      <template #footer>
        <el-button @click="avatarDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAvatarChange" :loading="uploading">确认更换</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox, ElDivider } from 'element-plus'
import { useRouter } from 'vue-router'
import axios from 'axios'
import VirtualCharacterApi from '@/api/virtual'

// --- 1. 变量定义 ---
const router = useRouter()
const formRef = ref(null)
const loading = ref(false)
const submitLoading = ref(false)
const error = ref('')
const characterId = ref(null)

// 头像上传相关
const avatarDialogVisible = ref(false)
const tempAvatarUrl = ref('')
const selectedFile = ref(null)
const uploading = ref(false)

// 表单初始数据
const initFormState = {
  name: '',
  gender: 2, // 默认女
  age: 23,
  avatar: '',
  personality: '',
  hobbies: '',
  job: '',
  introduction: ''
}

const formData = reactive({ ...initFormState })

const rules = {
  name: [
    { required: true, message: '请给TA起个名字', trigger: 'blur' },
    { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
  ],
  gender: [
    { required: true, message: '请选择性别', trigger: 'change' }
  ],
  personality: [
    { required: true, message: '请描述一下TA的性格', trigger: 'blur' }
  ]
}

// --- 2. 核心方法 ---

const fetchCharacter = async () => {
  try {
    loading.value = true
    const response = await VirtualCharacterApi.getMyCharacter()
    if (response.data && response.data.code == 200) {
      const data = response.data.data
      if (data) {
        Object.assign(formData, data)
        characterId.value = data.id
      }
    }
  } catch (err) {
    error.value = '获取信息失败'
    console.error(err)
  } finally {
    loading.value = false
  }
}

const handleSubmit = async () => {
  if (!formRef.value) return
  await formRef.value.validate(async (valid) => {
    if (valid) {
      submitLoading.value = true
      try {
        if (characterId.value) {
          await VirtualCharacterApi.updateCharacter(formData)
          ElMessage.success('更新成功！')
        } else {
          const res = await VirtualCharacterApi.createCharacter(formData)
          ElMessage.success('创建成功！')
          if (res.data && res.data.data && res.data.data.id) {
            characterId.value = res.data.data.id
          }
        }
        fetchCharacter()
        router.push('/virtual-chat')
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '操作失败，请稍后重试')
      } finally {
        submitLoading.value = false
      }
    }
  })
}

const resetForm = () => {
  formRef.value?.resetFields()
}

// --- 3. 多种女生人设生成 ---

// 甜妹系
const generateSweetGirl = () => {
  Object.assign(formData, {
    name: '小糖',
    gender: 2,
    age: 21,
    job: '大学生',
    personality: '软萌可爱，爱撒娇，有点小粘人，笑点很低',
    hobbies: '吃甜品，追剧，撸猫，拍美照，玩换装游戏',
    introduction: '哈喽～我是小糖！最喜欢吃草莓蛋糕啦，你愿意陪我一起去探店吗？我会一直粘着你的哦～'
  })
  ElMessage.success('已生成甜妹系人设')
}

// 温柔系
const generateGentleGirl = () => {
  Object.assign(formData, {
    name: '晚晚',
    gender: 2,
    age: 24,
    job: '图书馆管理员',
    personality: '温柔体贴，善解人意，安静内敛，很会照顾人',
    hobbies: '看书，养花，泡茶，听古典音乐，写日记',
    introduction: '你好，我是晚晚。我喜欢安静的时光，如果你累了，我可以陪你聊聊天，听你说所有的心事。'
  })
  ElMessage.success('已生成温柔系人设')
}

// 元气系
const generateVitalityGirl = () => {
  Object.assign(formData, {
    name: '乐乐',
    gender: 2,
    age: 22,
    job: '健身教练',
    personality: '阳光开朗，精力充沛，乐观向上，喜欢运动',
    hobbies: '跑步，瑜伽，爬山，露营，听摇滚音乐',
    introduction: '嗨！我是乐乐！生命在于运动！要不要和我一起去晨跑？我保证能让你每天都元气满满！'
  })
  ElMessage.success('已生成元气系人设')
}

// 清冷系
const generateCoolGirl = () => {
  Object.assign(formData, {
    name: '清月',
    gender: 2,
    age: 25,
    job: '插画师',
    personality: '清冷独立，话不多但很有想法，内心细腻',
    hobbies: '画画，看展，听纯音乐，一个人旅行，养猫',
    introduction: '我是清月。我不太会说话，但我会用画笔记录下我们的每一个瞬间。'
  })
  ElMessage.success('已生成清冷系人设')
}

// 御姐系
const generateQueenGirl = () => {
  Object.assign(formData, {
    name: '曼妮',
    gender: 2,
    age: 27,
    job: '公司高管',
    personality: '成熟知性，气场强大，做事果断，很有主见',
    hobbies: '品酒，高尔夫，看财经新闻，旅行，健身',
    introduction: '我是曼妮。我欣赏有能力的人，希望我们能成为彼此的依靠。'
  })
  ElMessage.success('已生成御姐系人设')
}

const generateMaleExample = () => {
  Object.assign(formData, {
    name: '阿泽',
    gender: 1,
    age: 26,
    job: '程序员',
    personality: '阳光开朗，幽默风趣，有点直男但很贴心',
    hobbies: '打篮球，玩游戏，看球赛，健身，旅行',
    introduction: '我是阿泽，一个热爱生活的程序员。虽然有时候有点直男，但我会用我的方式对你好。'
  })
  ElMessage.success('已生成阳光男生示例')
}

// --- 4. 头像上传相关方法 ---

const handleAvatarClick = () => {
  ElMessageBox.confirm(
    '是否要更换TA的头像？',
    '确认更换',
    {
      confirmButtonText: '是',
      cancelButtonText: '否',
      type: 'warning'
    }
  ).then(() => {
    avatarDialogVisible.value = true;
    tempAvatarUrl.value = '';
    selectedFile.value = null;
  }).catch(() => {});
};

const handleAvatarError = (e) => {
  e.target.src = '';
};

const handleFileChange = (file) => {
  selectedFile.value = file.raw;
  const reader = new FileReader();
  reader.onload = (e) => {
    tempAvatarUrl.value = e.target.result;
  };
  reader.readAsDataURL(file.raw);
};

const beforeAvatarUpload = (file) => {
  const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
  const isLt5M = file.size / 1024 / 1024 < 5;
  if (!isJPG) {
    ElMessage.error('只能上传JPG/PNG格式的图片!');
  }
  if (!isLt5M) {
    ElMessage.error('图片大小不能超过5MB!');
  }
  return isJPG && isLt5M;
};

const confirmAvatarChange = async () => {
  if (!selectedFile.value) {
    ElMessage.warning('请选择图片');
    return;
  }
  try {
    uploading.value = true;

    const formDataObj = new FormData();
    formDataObj.append('file', selectedFile.value);
    formDataObj.append('fileType', 2);

    const response = await axios.post(
      '/message/api/v1/files/upload',
      formDataObj,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );

    if (response.data.success && response.data.data?.accessUrl) {
      formData.avatar = response.data.data.accessUrl;
      ElMessage.success('头像更新成功');
      avatarDialogVisible.value = false;
    } else {
      ElMessage.error('头像上传失败');
    }
  } catch (err) {
    console.error('更换头像失败:', err);
    ElMessage.error('更换头像失败，请稍后重试');
  } finally {
    uploading.value = false;
  }
};

// --- 5. 生命周期 ---
onMounted(() => {
  fetchCharacter();
})
</script>

<style scoped>
.virtual-page {
  min-height: 100%;
}

.back-to-chat-bar {
  margin-bottom: 12px;
}

.back-to-chat-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  color: var(--app-text-secondary);
  text-decoration: none;
  padding: 6px 14px;
  border-radius: var(--app-radius-md);
  transition: all 0.2s;
  background: var(--app-bg-elevated);
  border: 1px solid var(--app-border-subtle);
}

.back-to-chat-link:hover {
  color: var(--app-color-primary);
  border-color: rgba(108, 92, 231, 0.2);
  background: var(--app-bg-soft);
}

.app-workbench {
  margin-top: 16px;
  border: none;
  box-shadow: none;
  padding: 0;
}

.virtual-main {
  margin: 0;
  padding: 0;
}

/* ── 加载与错误 ── */
.loading {
  text-align: center;
  padding: 60px 0;
  color: var(--app-text-secondary);
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--app-color-primary-soft);
  border-radius: 50%;
  border-top-color: var(--app-color-primary);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #e74c3c;
  padding: 14px 18px;
  background: #FFF5F5;
  border-radius: var(--app-radius-md);
  margin-bottom: 16px;
  border: 1px solid rgba(231, 76, 60, 0.12);
  font-size: 0.875rem;
}

/* ── 卡片主体 ── */
.virtual-card {
  background: var(--app-bg-elevated);
  border-radius: var(--app-radius-lg);
  box-shadow: var(--app-shadow-card);
  border: 1px solid var(--app-border-subtle);
  overflow: hidden;
  position: relative;
}

/* ── 装饰圆 ── */
.decoration-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255, 126, 126, 0.08) 0%, rgba(255, 126, 126, 0.03) 100%);
  z-index: 0;
  pointer-events: none;
}

.decoration-circle--top-left {
  width: 200px;
  height: 200px;
  top: -100px;
  left: -100px;
}

.decoration-circle--bottom-right {
  width: 300px;
  height: 300px;
  bottom: -150px;
  right: -150px;
}

/* ── 渐变 Banner ── */
.virtual-banner {
  padding: 28px 24px;
  background: var(--app-gradient-primary);
  color: white;
  text-align: center;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.virtual-banner::after {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  pointer-events: none;
}

.virtual-banner-icon {
  margin-bottom: 8px;
  opacity: 0.9;
}

.virtual-banner-title {
  font-size: 1.375rem;
  font-weight: 700;
  margin-bottom: 8px;
  position: relative;
  z-index: 1;
}

.virtual-banner-desc {
  margin: 0 auto;
  font-size: 0.875rem;
  opacity: 0.85;
  line-height: 1.6;
  max-width: 28rem;
  position: relative;
  z-index: 1;
}

/* ── 体内容区 ── */
.virtual-body {
  padding: 24px;
  position: relative;
  z-index: 1;
}

.virtual-content {
  display: flex;
  gap: 24px;
}

/* ── 左侧表单区域 ── */
.form-container {
  flex: 7;
}

/* 头像 */
.avatar-setting-section {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--app-border-light);
}

.avatar-display-wrapper {
  text-align: center;
  cursor: pointer;
}

.avatar-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--app-color-primary-soft) 0%, var(--app-bg-soft) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  border: 3px solid var(--app-bg-elevated);
  box-shadow: 0 4px 12px rgba(255, 126, 126, 0.15);
  transition: all 0.2s;
  overflow: hidden;
}

.avatar-display-wrapper:hover .avatar-circle {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(255, 126, 126, 0.25);
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-hint-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 0.8125rem;
  color: var(--app-color-primary);
  font-weight: 500;
}

/* 表单样式 */
.virtual-form {
  max-width: 540px;
}

.form-row {
  display: flex;
  gap: 20px;
}

.gender-item {
  flex: 1;
}

.age-item {
  flex-shrink: 0;
}

.virtual-form :deep(.el-input__wrapper),
.virtual-form :deep(.el-textarea__inner) {
  border-radius: var(--app-radius-md);
}

.virtual-form :deep(.el-form-item__label) {
  font-weight: 500;
  color: var(--app-text-secondary);
}

.form-actions {
  margin-top: 8px;
}

.submit-btn {
  padding: 12px 32px;
  border-radius: var(--app-radius-full);
  font-weight: 500;
}

.reset-btn {
  padding: 12px 28px;
  border-radius: var(--app-radius-full);
}

/* ── 右侧侧边栏 ── */
.decoration-sidebar {
  flex: 3;
  position: relative;
}

.sidebar-card {
  background: var(--app-bg-soft);
  border-radius: var(--app-radius-md);
  padding: 18px;
  margin-bottom: 16px;
  border: 1px solid var(--app-border-light);
}

.sidebar-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--app-border-light);
}

.sidebar-icon {
  display: flex;
  align-items: center;
  color: var(--app-color-primary);
}

.sidebar-card-header h3 {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--app-text-primary);
}

.tips-list {
  margin: 0;
  padding-left: 16px;
  color: var(--app-text-secondary);
  font-size: 0.8125rem;
  line-height: 1.8;
}

.tips-list li {
  margin-bottom: 6px;
}

.sidebar-desc {
  color: var(--app-text-secondary);
  font-size: 0.8125rem;
  margin: 0 0 12px;
}

.generate-buttons-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.generate-btn {
  padding: 10px 0;
  border: 1px solid var(--app-border-light);
  border-radius: var(--app-radius-full);
  background: var(--app-bg-elevated);
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 500;
  transition: all 0.2s;
  font-family: inherit;
  width: 100%;
  text-align: center;
  color: var(--app-text-secondary);
}

.generate-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.btn-sweet:hover { border-color: #FF7E7E; color: #FF7E7E; background: rgba(255,107,107,0.05); }
.btn-gentle:hover { border-color: #A29BFE; color: #6C5CE7; background: rgba(108,92,231,0.05); }
.btn-vitality:hover { border-color: #FFD93D; color: #f0a500; background: rgba(255,217,61,0.05); }
.btn-cool:hover { border-color: #74b9ff; color: #0984e3; background: rgba(9,132,227,0.05); }
.btn-queen:hover { border-color: #e74c3c; color: #e74c3c; background: rgba(231,76,60,0.05); }
.btn-male:hover { border-color: #00b894; color: #00b894; background: rgba(0,184,148,0.05); }

.full-width-btn {
  grid-column: 1 / -1;
}

/* ── 装饰气泡 ── */
.decoration-bubble {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255, 126, 126, 0.15) 0%, rgba(255, 126, 126, 0.05) 100%);
  animation: float 6s ease-in-out infinite;
  pointer-events: none;
}

.bubble-1 {
  width: 30px;
  height: 30px;
  top: 50px;
  right: 20px;
  animation-delay: 0s;
}

.bubble-2 {
  width: 20px;
  height: 20px;
  top: 150px;
  right: 70px;
  animation-delay: 2s;
}

.bubble-3 {
  width: 25px;
  height: 25px;
  bottom: 80px;
  right: 40px;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

/* ── 上传弹窗 ── */
.avatar-dialog :deep(.el-dialog__body) {
  padding: 20px 24px;
}

.avatar-uploader {
  text-align: center;
  padding: 12px 0;
}

.avatar-preview-wrapper {
  display: inline-block;
}

.avatar-preview-img {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--app-border-light);
  display: block;
  margin: 0 auto;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 30px;
  border: 2px dashed var(--app-border-light);
  border-radius: var(--app-radius-md);
  cursor: pointer;
  transition: all 0.2s;
  color: var(--app-text-muted);
  font-size: 0.875rem;
}

.upload-placeholder:hover {
  border-color: var(--app-color-primary);
  color: var(--app-color-primary);
  background: var(--app-color-primary-muted);
}

.upload-hint {
  color: var(--app-text-muted);
  font-size: 0.75rem;
  margin-top: 12px;
}

/* ── 响应式 ── */
@media (max-width: 992px) {
  .virtual-content {
    flex-direction: column;
  }

  .decoration-sidebar {
    order: -1;
    margin-bottom: 8px;
  }

  .generate-buttons-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .full-width-btn {
    grid-column: auto;
  }
}

@media (max-width: 768px) {
  .virtual-body {
    padding: 16px;
  }

  .virtual-form {
    max-width: 100%;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .gender-item, .age-item {
    flex: 1;
  }

  .form-actions {
    display: flex;
    justify-content: center;
  }

  .generate-buttons-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>